import { InjectionToken } from '@angular/core'
import * as L from 'leaflet'
import { BehaviorSubject } from 'rxjs'

export const MAP = new InjectionToken<BehaviorSubject<L.DrawMap>>('vt.map')
export const DEV_OR_LOCALHOST = new InjectionToken<BehaviorSubject<string>>('vt.mode')
